import React from 'react';
import { v4 as uuid } from 'uuid';
import { Icon } from 'Permafrost/index';
import { StyledSelect } from './Select.styles';
import classNames from 'classnames';
export const Select = (props) => {
    const { id, className, disabled, initialText, onChange, options, size = 'medium', style = {}, value, variant, onClick, } = props;
    const selectId = uuid();
    return (React.createElement(StyledSelect, { className: className, "data-cy": props['data-cy'], id: id, style: style },
        React.createElement("div", { className: classNames('Select__container', size, variant), onClick: (e) => (onClick ? onClick(e) : null) },
            React.createElement("select", { onChange: onChange, value: value, disabled: disabled, id: selectId },
                initialText && (React.createElement("option", { disabled: true, value: "" }, initialText)),
                options.map((o) => {
                    const key = uuid();
                    return (React.createElement("option", { key: key, value: o.value }, o.name));
                })),
            React.createElement(Icon, { className: "chevron", name: "chevron-down", size: size === 'small' ? [10] : [12] }))));
};
//# sourceMappingURL=Select.js.map